import classnames from "classnames";
import pluralize from "pluralize";
import {FaCheck} from "react-icons/fa6";

import {Icon} from "@/components/icon/Icon.tsx";
import {thousandSeparatedInt} from "@/lib/format.tsx";
import {BillingPeriod} from "@/lib/types/billing.ts";
import {SubscriptionPackTier} from "@/pages/billing/v2/types.ts";

import styles from "./Tier.module.scss";

export interface TierProps {
  tier?: SubscriptionPackTier;
  lines?: string[];
  billingPeriod?: BillingPeriod;
  subtitle: string;
  active: boolean;
  showTierLimits?: boolean;
}

export const Tier = ({tier, billingPeriod, subtitle, active, lines = [], showTierLimits = true}: TierProps) => {
  if (!tier) {
    return false;
  }
  return (
    <div className={classnames(styles.plan, {[styles.active]: active}, "rounded-4 p-5 h-100")}>
      <div className="pulseTextBodySmall text-uppercase pulse-color-gray-600 mb-2">{subtitle}</div>
      <div className="pulseTextH1 d-flex align-items-center">
        $
        <span className="pulseTextH1Bold fs-1 mx-1">
          {thousandSeparatedInt(billingPeriod === BillingPeriod.MONTH ? tier.price_monthly : tier.price_annual)}
        </span>
        / mo
      </div>
      <div className="mt-5">
        <ul className="m-0 list-unstyled lh-lg">
          {showTierLimits &&
            tier.limits.map((limit, i) => (
              <li key={`limit-${i}`}>
                <Icon icon={FaCheck} className="pulse-color-green-500" display="inline" />
                <span className="pulseTextBody pulse-color-gray-850">
                  {limit.value_alt || thousandSeparatedInt(limit.value)} {pluralize(limit.limit_name, limit.value)}
                </span>
              </li>
            ))}
          {lines.map((line, i) => (
            <li key={`common-limit-${i}`}>
              <Icon icon={FaCheck} className="pulse-color-green-500" display="inline" />
              <span className="pulseTextBody pulse-color-gray-850">{line}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
